var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { styled } from 'styled-components';
import { Tooltip } from '@hn-ui/tooltips';
import { Clock } from '@hn-ui/icons';
import { formatDate } from '../../../utils/formatDate';
import { ExpandRowButton } from '../ExpandRowButton';
import { zIndexes } from '../../../constants/DOM';
import { checkIfStudentRow } from '../tableConfig';
var MAX_NAME_LENGTH = 15;
var cutText = function (str) {
    if (str.length > MAX_NAME_LENGTH) {
        return str.substring(0, MAX_NAME_LENGTH - 1) + "...";
    }
    return str;
};
var ScCell = styled.div.withConfig({ displayName: "ScCell", componentId: "sc-1vkg6sf" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  position: relative;\n  text-decoration: none;\n  text-align: left;\n"], ["\n  color: ", ";\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  position: relative;\n  text-decoration: none;\n  text-align: left;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.blue50;
});
var ScIcon = styled.div.withConfig({ displayName: "ScIcon", componentId: "sc-4586k1" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  left: -5px;\n  top: 50%;\n  transform: translate(-100%, -50%);\n  line-height: 0;\n  z-index: 1;\n"], ["\n  position: absolute;\n  left: -5px;\n  top: 50%;\n  transform: translate(-100%, -50%);\n  line-height: 0;\n  z-index: 1;\n"])));
var ScGroupCell = styled(ScCell).withConfig({ displayName: "ScGroupCell", componentId: "sc-t6n5u8" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  color: ", ";\n  vertical-align: middle;\n"], ["\n  display: inline-block;\n  color: ", ";\n  vertical-align: middle;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black60;
});
export var StudentNameCell = function (_a) {
    var onNameClick = _a.onNameClick, cellProps = __rest(_a, ["onNameClick"]);
    var original = cellProps.row.original;
    var nameContent = (_jsxs("span", { children: [cutText(original.name), _jsx(ExpandRowButton, __assign({}, cellProps), void 0)] }, void 0));
    var cellRef = React.useRef(null);
    if (!checkIfStudentRow(original)) {
        return _jsx(ScGroupCell, { children: original.name }, void 0);
    }
    return (_jsxs(ScCell, __assign({ "data-testid": original.id, ref: cellRef, onClick: onNameClick }, { children: [original.isOutdated && cellRef.current && (_jsx(ScIcon, { children: _jsx(Tooltip, __assign({ placement: 'bottom-start', shiftOnOverflow: true, maxWidth: '226px', flip: false, mountNode: cellRef.current, zIndex: zIndexes.innerTableTooltip, content: _jsxs(_Fragment, { children: ["No usage since", _jsx("br", {}, void 0), formatDate(original.lastActiveAt) + ". Student skill data is outdated."] }, void 0) }, { children: _jsx(Clock, { size: 16, color: 'black60' }, void 0) }), void 0) }, void 0)), original.name.length > MAX_NAME_LENGTH && cellRef.current ? (_jsx(Tooltip, __assign({ placement: 'bottom-start', maxWidth: 'auto', flip: false, content: original.name, mountNode: cellRef.current, zIndex: zIndexes.innerTableTooltip }, { children: nameContent }), void 0)) : (nameContent)] }), void 0));
};
var ScHeader = styled.div.withConfig({ displayName: "ScHeader", componentId: "sc-1kecdg4" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  width: 100%;\n  height: 100%;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  width: 100%;\n  height: 100%;\n"])));
export var NameHeaderCell = function (_a) {
    var children = _a.children;
    return (_jsxs(ScHeader, { children: [_jsx("span", { children: "Student" }, void 0), children] }, void 0));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
